import api from '../../../shared/services/api';

const BASE = '/api/queue-dashboard';

export const queueService = {
  getStats: () => api.get(`${BASE}/stats`).then(r => r.data),
  getJobs: (status = 'failed', page = 1, limit = 20) =>
    api.get(`${BASE}/jobs`, { params: { status, page, limit } }).then(r => r.data),
  getEnvioProgress: (logId) => api.get(`${BASE}/envio/${logId}`).then(r => r.data),
  getEnviosAtivos: () => api.get(`${BASE}/envios-ativos`).then(r => r.data),
  retryAll: () => api.post(`${BASE}/retry-all`).then(r => r.data),
  retryJob: (jobId) => api.post(`${BASE}/retry/${jobId}`).then(r => r.data),
  clean: () => api.post(`${BASE}/clean`).then(r => r.data),
  pause: () => api.post(`${BASE}/pause`).then(r => r.data),
  resume: (sessionName) => api.post(`${BASE}/resume`, { sessionName }).then(r => r.data),
  getBlockedSessions: () => api.get(`${BASE}/blocked-sessions`).then(r => r.data),
};
